import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Pages/Login";
import Dashboard from "./Pages/Dashbord";
import { Toaster } from "react-hot-toast";

export default function App() {
    const isAuth = !!localStorage.getItem("token");

    return (
        <>
            <Toaster />
            <BrowserRouter>
                
                <Routes>
                    {/* صفحة تسجيل الدخول */}
                    <Route path="/login" element={<Login />} />

                    {/* صفحة الداشبورد */}
                    <Route
                        path="/dashboard"
                        element={isAuth ? <Dashboard /> : <Navigate to="/login" />}
                    />

                    {/* أي رابط آخر */}
                    <Route path="*" element={<Navigate to="/dashboard" />} />
                </Routes>
            </BrowserRouter>
        </>
    );
}
